import axios from "../lib/axios";

export const createMember = async (payload, token) => {
  try {
    const response = await axios.post("/members/add", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    const serverMessage =
      error?.response?.data?.message || "Failed to create member";
    throw new Error(serverMessage);
  }
};

// Update member details
export const updateMember = async (id, payload) => {
  try {
    const response = await axios.put(`/members/update/${id}`, payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update member"
    );
  }
};

// Delete a member
export const deleteMember = async (id) => {
  try {
    const response = await axios.delete(`/members/delete/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to delete member"
    );
  }
};

export const updateMemberStatus = async (id, status) => {
  try {
    const response = await axios.patch(`/members/status/${id}`, { status });
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update member status"
    );
  }
};

export const updateMemberAuthStatus = async (id, status) => {
  try {
    const response = await axios.patch(`/members/status-auth/${id}`, {
      status,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update member status"
    );
  }
};

export const getMembersByStatus = async (
  status,
  page = 1,
  limit = 10,
  filters = {}
) => {
  try {
    const params = { limit };

    if (page) {
      params.page = page;
    }

    // Dynamic parameter based on searchFilter
    if (filters.searchTerm && filters.searchFilter) {
      switch (filters.searchFilter) {
        case "name":
          params.name = filters.searchTerm;
          break;
        case "memberId":
          params.membershipId = filters.searchTerm;
          break;
        case "all":
        default:
          params.searchTerm = filters.searchTerm;
          break;
      }
    } else if (filters.searchTerm) {
      params.searchTerm = filters.searchTerm;
    }

    // Keep the existing logic for other filters
    Object.entries(filters).forEach(([key, value]) => {
      if (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        key !== "searchTerm" &&
        key !== "searchFilter"
      ) {
        params[key] = value;
      }
    });

    const response = await axios.get(`/members/status/${status}`, {
      params,
    });

    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch members"
    );
  }
};

export const memberLogin = async (payload) => {
  try {
    const response = await axios.post(`/members/login`, payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update member status"
    );
  }
};

export const getMemberByToken = async (token) => {
  try {
    const response = await axios.get(`/members/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch member by token"
    );
  }
};

// 🔹 2. Get member by ID (no token required)
export const getMemberById = async (memberId) => {
  try {
    const response = await axios.get(`/members/me/${memberId}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch member by ID"
    );
  }
};

export const getMembersAll = async (params = {}) => {
  try {
    const response = await axios.get("/members/get-all-members", {
      params: {
        memberAuthStatus: "active",
        ...params,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch member details"
    );
  }
};

export const getCurrentOfficeBears = async (params = {}) => {
  try {
    const response = await axios.get("/members/office-bearers", {
      params: {
        memberAuthStatus: "active",
        ...params,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch member details"
    );
  }
};

// 🔹 Send verification email
export const sendVerificationEmail = async (payload) => {
  try {
    const response = await axios.post(
      "/members/auth/send-verification-email",
      payload
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to send verification email"
    );
  }
};

// 🔹 Verify email OTP
export const verifyEmailOtp = async (payload) => {
  try {
    const response = await axios.post(
      "/members/auth/verify-email-otp",
      payload
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to verify email OTP"
    );
  }
};

// 🔹 Send mobile OTP
export const sendMobileOtp = async (payload) => {
  try {
    const response = await axios.post("/members/auth/send-mobile-otp", payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to send mobile OTP"
    );
  }
};

// 🔹 Verify mobile OTP
export const verifyMobileOtp = async (payload) => {
  try {
    const response = await axios.post(
      "/members/auth/verify-mobile-otp",
      payload
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to verify mobile OTP"
    );
  }
};

export const changePassword = async (payload) => {
  try {
    const response = await axios.post("/members/auth/change-password", payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to verify mobile OTP"
    );
  }
};

//  Send Forgot Password OTP
export const sendForgotPasswordOtp = async (email) => {
  try {
    const response = await axios.post("/members/auth/forgot-password", {
      email,
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to send OTP");
  }
};

//  Resend Forgot Password OTP
export const resendForgotPasswordOtp = async (email) => {
  try {
    const response = await axios.post("/members/auth/forgot-password/resend", {
      email,
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to resend OTP");
  }
};

//  Verify Forgot Password OTP
export const verifyForgotPasswordOtp = async (email, otp) => {
  try {
    const response = await axios.post("/members/auth/forgot-password/verify", {
      email,
      otp,
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to verify OTP");
  }
};

// Call this function from your frontend form submission
export const resetForgotPasswordApi = async (payload) => {
  try {
    const response = await axios.post(
      "/members/auth/forgot-password/reset",
      payload
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to reset password"
    );
  }
};
